/**
 * Creates loading icon which appends it to vuetify's v-btn component.
 * Hides existing icon and disables it too
 * @param target HTML element
 * @returns function that deletes element, unmounts loading indicator component and re-enables v-btn
 */
export function showLoadingButton(target) {
    const refBtn = target.classList.contains("v-btn")
        ? target
        : target.closest(".v-btn");
    const span = document.createElement("span");
    span.className = "v-btn__loader";
    const icon = document.createElement("i");
    icon.className = "fa fa-solid fa-spinner-third fa-spin-pulse white--text";
    span.append(icon);
    refBtn.classList.add("v-btn--loading");
    refBtn.setAttribute("disabled", "disabled");
    refBtn.classList.add("v-btn--disabled");
    refBtn.append(span);
    return function () {
        span.remove();
        refBtn.removeAttribute("disabled");
        refBtn.classList.remove("v-btn--disabled");
        refBtn.classList.remove("v-btn--loading");
    };
}
